<template>
  <div class="edu-info-wrap">
    <div class="low-edu">
      <div class="title" style="width: 140px"><span style="color: red">*</span>Degree</div>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-input v-model="degreeSchool" placeholder="Graduation School"></el-input>
        </div>
        <div class="item">
          <el-date-picker
            v-model="degreeStartDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="degreeEndDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="degreeMajor" placeholder="Major"></el-input>
        </div>
      </div>
    </div>
    <div class="middle-edu">
      <div class="title" style="width: 140px">Diploma</div>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-input v-model="diplomaSchool" placeholder="Graduation School"></el-input>
        </div>
        <div class="item">
          <el-date-picker
            v-model="diplomaStartDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="diplomaEndDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="diplomaMajor" placeholder="Major"></el-input>
        </div>
      </div>
    </div>
    <div class="middle-edu">
      <div class="title" style="width: 140px">A Level</div>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-input v-model="aLevelSchool" placeholder="Graduation School"></el-input>
        </div>
        <div class="item">
          <el-date-picker
            v-model="aLevelStartDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="aLevelEndDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="aLevelMajor" placeholder="Major"></el-input>
        </div>
      </div>
    </div>
    <div class="middle-edu"
      v-for="(item, index) in list"
         :key="index"
    >
      <div class="title" style="width: 140px">
        <el-select
          class="base-input"
          v-model="item.qualification"
        >
          <el-option
            :key="subIndex"
            :label="subItem.label"
            :value="subItem.value"
            v-for="(subItem, subIndex) in item.select"
          ></el-option>
        </el-select>
      </div>
      <div class="detail-wrap" style="position: relative">
        <div class="item" style="margin-left: 0">
          <el-input v-model="item.school" placeholder="Graduation School"></el-input>
        </div>
        <div class="item">
          <el-date-picker
            v-model="item.startDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="item.endDate"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="item.major" placeholder="Major"></el-input>
        </div>
        <div class="delete" style="position: absolute; right: -50px; top: 6px" @click="deleteList(index)">
          delete
        </div>
      </div>
    </div>
    <!--<div class="high-edu" v-show="highEduShows.includes('SHUO_SHI')">
      <div class="title">硕士</div>
      <span class="delete" @click="handleDeleteItem('SHUO_SHI')">删除</span>
      <div class="detail-wrap">
        <div class="item">
          <el-input
            id="graduHSchool"
            @focus="onHSchoolFocus"
            @blur="onHSchoolBlur"
            v-model="graduHSchool"
            :placeholder="ssPlaceholder"></el-input>
           <transition name="slide-fade">
              <div v-if="ssShow" class="zoom-search-menu">
                <div
                  class="zoom-search-menu-item"
                  :key="index"
                  :class="[graduHSchool === item.name ? 'hover' : '']"
                  @click="onClickCollageItem(item, 'ss')"
                  v-for="(item, index) in collageList">
                    &lt;!&ndash; <span class="province">{{item.province}}</span> &ndash;&gt;
                    <span :title="item.name" class="name">{{item.name}}</span>
                </div>
              </div>
            </transition>
        </div>
        <div class="item">
          <el-date-picker
            id="highStartTime"
            v-model="highStartTime"
            type="month"
            placeholder="入学时间"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="highEndTime"
            type="month"
            placeholder="毕业时间"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="departmentHMajor" placeholder="请输入院系"></el-input>
        </div>
      </div>
    </div>
    <div class="highest-edu" v-show="highEduShows.includes('BO_SHI')">
      <div class="title">博士</div>
      <span class="delete" @click="handleDeleteItem('BO_SHI')">删除</span>
      <div class="detail-wrap">
        <div class="item">
          <el-input
            @focus="onHESchoolFocus"
            @blur="onHESchoolBlur"
            v-model="graduHESchool"
            :placeholder="bsPlaceholder"></el-input>
          <transition name="slide-fade">
              <div v-if="bsShow" class="zoom-search-menu">
                <div
                  class="zoom-search-menu-item"
                  :key="index"
                  :class="[graduHESchool === item.name ? 'hover' : '']"
                  @click="onClickCollageItem(item, 'bs')"
                  v-for="(item, index) in collageList">
                    &lt;!&ndash; <span class="province">{{item.province}}</span> &ndash;&gt;
                    <span :title="item.name" class="name">{{item.name}}</span>
                </div>
              </div>
            </transition>
        </div>
        <div class="item">
          <el-date-picker
            id="highestStartTime"
            v-model="highestStartTime"
            type="date"
            placeholder="入学时间"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="highestEndTime"
            type="month"
            placeholder="毕业时间"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="departmentHEMajor" placeholder="请输入院系"></el-input>
        </div>
      </div>
    </div>-->
    <div v-show="clickCounter <= 3" class="bottom-btn">
      <el-button @click="addClickCounter" style="display:block;margin: 0 auto;width: 120px;color: #007ab0;" type="text" icon="el-icon-plus">Add educational experience</el-button>
    </div>
  </div>
</template>

<script>
import { getCollageData } from '@/api/search'
import $ from 'jquery'
const BO_SHI = 'BO_SHI'
const SHUO_SHI = 'SHUO_SHI'
export default {
  data () {
    return {
      degreeSchool: '',
      degreeStartDate: '',
      degreeEndDate: '',
      degreeMajor: '',
      diplomaSchool: '',
      diplomaStartDate: '',
      diplomaEndDate: '',
      diplomaMajor: '',
      aLevelSchool: '',
      aLevelStartDate: '',
      aLevelEndDate: '',
      aLevelMajor: '',
      clickCounter: 0,
      list: []
    }
  },
  mounted() {
    this.searchCollage()
  },
  methods: {
    deleteList (index) {
      this.clickCounter -= 1
      this.$delete(this.list, index)
    },
    searchCollage(key = '合肥') {
      getCollageData(key).then(res => {
        if (res.code === '10000') {
          this.collageList = res.data
        }
      })
    },
    onMSchoolFocus() {
      this.searchCollage(this.graduMSchool)
      this.bkPlaceholder = '请输入搜索条件'
      this.bkShow = true
    },
    onMSchoolBlur() {
      this.bkShow = false
      this.bkPlaceholder = '毕业院校'
    },
    onHSchoolFocus() {
      this.ssShow = true
      this.ssPlaceholder = '请输入搜索条件'
      this.searchCollage(this.graduHSchool)
    },
    onHSchoolBlur() {
      this.ssShow = false
      this.ssPlaceholder = '毕业院校'
    },
    onHESchoolFocus() {
      this.searchCollage(this.graduHESchool)
      this.bsPlaceholder = '请输入搜索条件'
      this.bsShow = true
    },
    onHESchoolBlur() {
      this.bsShow = false
      this.bsPlaceholder = '毕业院校'
    },
    onClickCollageItem(item, flag) {
      switch (flag) {
        case 'bk':
          this.graduMSchool = item.name
          break
        case 'ss':
          this.graduHSchool = item.name
          break
        case 'bs':
          this.graduHESchool = item.name
          break
        default :
          this.graduHSchool = item.name
          break
      }
    },
    addClickCounter() {
      this.clickCounter += 1
      this.list.push({
        school: '',
        qualification: 'Master',
        select: [{
          label: 'Master',
          value: 'Master'
        }, {
          label: 'Doctoral',
          value: 'Doctoral'
        }, {
          label: 'Secondary',
          value: 'Secondary'
        }, {
          label: 'Primary',
          value: 'Primary'
        }],
        startDate: '',
        endDate: '',
        major: '',
      })
      // if (!this.highEduShows.includes(SHUO_SHI)) {
      //   this.highEduShows.push(SHUO_SHI)
      //   return
      // }
      // if (!this.highEduShows.includes(BO_SHI)) {
      //   this.highEduShows.push(BO_SHI)
      //   return
      // }
    },
    handleDeleteItem(key) {
      if (key === SHUO_SHI) {
        const index = this.highEduShows.findIndex(it => it === key)
        this.highEduShows.splice(index, 1)
        this.highStartTime = ''
        this.highEndTime = ''
        this.graduHSchool = ''
        this.departmentHMajor = ''
      }
      if (key === BO_SHI) {
        const index = this.highEduShows.findIndex(a => a === key)
        this.highEduShows.splice(index, 1)
        this.highestStartTime = ''
        this.highestEndTime = ''
        this.graduHESchool = ''
        this.departmentHEMajor = ''
      }
    },
    handleSearchCollage(val) {
      if (!val) {
        setTimeout(() => {
          this.searchCollage()
        }, 300)
        return
      }
      setTimeout(() => {
        this.searchCollage(val)
      }, 300)
    }
  },
  watch: {
    graduMSchool(newVal) {
      this.handleSearchCollage(newVal)
    },
    graduHSchool(newVal) {
      this.handleSearchCollage(newVal)
    },
    graduHESchool(newVal) {
      this.handleSearchCollage(newVal)
    }
  }
}
</script>

<style lang="stylus">
  .edu-info-wrap
    margin-top 24px
    .high-edu, .middle-edu, .low-edu, .highest-edu
      position relative
      display flex
      margin-bottom 24px
      .delete
        position absolute
        top 8px
        right -40px
        font-size 14px
        color #f03b3b
        cursor pointer
      .title
        width 115px
        line-height 40px
        font-size 14px
        font-weight bold
        color #333
      .detail-wrap
        flex 1
        display flex
        .item
          position relative
          flex 1
          margin-left 24px
          .zoom-search-menu
            overflow scroll
            position absolute
            top 44px
            left 0
            width 100%
            max-height 200px
            z-index 1001
            //border 1px solid #e4e7ed
            border-radius 4px
            background-color #ffffff
            box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
            box-sizing border-box
            margin 5px 0
            .zoom-search-menu-item
              display flex
              font-size 12px
              padding 0 20px
              position relative
              white-space nowrap
              overflow hidden
              text-overflow ellipsis
              color #606266
              height 34px
              line-height 34px
              cursor pointer
              overflow hidden
              box-sizing border-box
              .province
                width 50px
                flex 0 0 50px
                max-width 50px
                min-width 50px
              .name
                flex 1
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
              &:hover
                background-color #f5f7fa
              &.hover
                background-color #f5f7fa
            &.slide-fade-enter-active
              transition all .3s ease
            &.slide-fade-leave-active
              transition all .3s ease
            &.slide-fade-enter, .slide-fade-leave-to
              transform translateX(10px)
              opacity 0
          .el-input
            width 100%
</style>



// WEBPACK FOOTER //
// src/components/edu-info/edu-info.vue